import { Modal, Button } from "antd";
import { useCallback } from "react";
import { settingService } from "/app/src/services";
import { useTranslation } from "react-i18next";
const { confirm } = Modal;

/**
 * DeleteForm component.
 * @param {object} props - React component properties.
 * @param {string} props.settingId - The ID of the setting to be deleted.
 * @param {function} props.refresh - The callback function to refresh the list.
 * @returns {JSX.Element} The rendered DeleteForm component.
 */
export default function DeleteForm(props) {
  const { t } = useTranslation();

  /**
   * Shows a confirmation modal to delete a channel.
   * @param {string} okText - The text for the OK button.
   * @param {string} cancelText - The text for the Cancel button.
   * @param {string} titleText - The title text of the confirmation modal.
   * @param {string} settingId - The identifier of the channel setting to delete.
   * @param {function} refresh - The callback to refresh the list of channels after deletion.
   */
  function ShowConfirm(okText, cancelText, titleText, settingId, refresh) {
    confirm({
      okText,
      okButtonProps: { type: "danger" },
      cancelText,
      title: titleText,
      onOk() {
        //refresh the list of channels if channel successfully removed
        settingService.deleteSingle(settingId).then((response) => {
          if (response.deleted === "true") {
            refresh();
          }
        });
      },
    });
  }

  const deleteForm = useCallback(() => {
    ShowConfirm(
      t("delete"),
      t("do_not_delete"),
      t("confirm_delete_channel"),
      props.settingId,
      props.refresh,
    );
  }, [props.settingId, props.refresh, t]);
  return (
    <Button type="danger" className="btn-delete" onClick={deleteForm}>
      {t("delete")} {t("channel")}
    </Button>
  );
}
